export const PalfriesCatalogId = 5341
export const PalfriesAvailabilityPlanId = 2332
export const PalfriesSennisRoundTripItemId = 20046
